export const getters = {
  articles (state) {
    return state.articles
  },
  article (state) {
    return state.article
  },  
  pagination(state){
    return state.pagination
  }
}
